import React, { useEffect, useRef } from "react";
import { gradePixel } from "../../video/grade/grade";

// How the brightness and the colours of the frame are spread, before (grey) and after (colour) the grade. Clipped black or white shows as a spike at the edge.
export default function Histogram({ frame, params, lut }) {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas || !frame) return;
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;
    const before = [new Float32Array(64), new Float32Array(64), new Float32Array(64)];
    const after = [new Float32Array(64), new Float32Array(64), new Float32Array(64)];
    const d = frame.data;
    for (let i = 0; i < d.length; i += 4) {
      const c = [d[i] / 255, d[i + 1] / 255, d[i + 2] / 255];
      const g = gradePixel(c, params, lut);
      for (let k = 0; k < 3; k += 1) { before[k][Math.min(63, Math.floor(c[k] * 64))] += 1; after[k][Math.min(63, Math.floor(g[k] * 64))] += 1; }
    }
    const peak = Math.max(1, ...before.flatMap((h) => Array.from(h).slice(1, 63)), ...after.flatMap((h) => Array.from(h).slice(1, 63)));
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#0b1626";
    ctx.fillRect(0, 0, W, H);
    ctx.strokeStyle = "rgba(255,255,255,0.08)";
    for (let q = 1; q < 4; q += 1) { ctx.beginPath(); ctx.moveTo((W * q) / 4, 0); ctx.lineTo((W * q) / 4, H); ctx.stroke(); }
    const draw = (hists, colors, fill) => hists.forEach((h, k) => {
      ctx.beginPath();
      ctx.moveTo(0, H);
      for (let b = 0; b < 64; b += 1) ctx.lineTo((b / 63) * W, H - Math.min(1, h[b] / peak) * (H - 4));
      ctx.lineTo(W, H);
      ctx.closePath();
      if (fill) { ctx.fillStyle = colors[k]; ctx.fill(); } else { ctx.strokeStyle = colors[k]; ctx.lineWidth = 1.5; ctx.stroke(); }
    });
    draw(before, ["rgba(200,200,200,0.7)", "rgba(200,200,200,0.7)", "rgba(200,200,200,0.7)"], false);
    ctx.globalCompositeOperation = "lighter";
    draw(after, ["rgba(255,70,70,0.55)", "rgba(70,255,90,0.55)", "rgba(80,120,255,0.55)"], true);
    ctx.globalCompositeOperation = "source-over";
  }, [frame, params, lut]);
  return <canvas ref={ref} width={256} height={90} className="w-full h-auto block rounded-lg border border-navy-border" aria-label="Histogram of the frame" />;
}
